import { handleApiError } from 'utils/api';
import { env } from '../../../constants';
import {
  NotificationPreferences,
  NotificationPreferencesResponse
} from './types';

export const updateNotificationPreferences = async (
  token: string | undefined,
  preferences: NotificationPreferences,
  pushPermission: boolean,
  refId: string
): Promise<null | undefined> => {
  if (!token) {
    return undefined;
  }

  const response = await fetch(
    `${env.VITE_API_BASE_URL}/preferences/${refId}`,
    {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        type: 'NOTIFICATIONS',
        value: preferences,
        pushPermission
      })
    }
  );

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
    }
    if (response.status === 400) {
      await handleApiError(response);
    }
  }

  return null;
};

export const getNotificationPreferences = async (
  token: string | undefined
): Promise<NotificationPreferencesResponse | undefined> => {
  if (!token) {
    return undefined;
  }

  const response = await fetch(`${env.VITE_API_BASE_URL}/preferences`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
      return undefined;
    }
    if (response.status === 400) {
      await handleApiError(response);
    }
  }

  return response.json() as Promise<NotificationPreferencesResponse>;
};
